import { render, staticRenderFns } from "./ScreenBulk.vue?vue&type=template&id=8e3162b0&"
import script from "./ScreenBulk.vue?vue&type=script&lang=js&"
export * from "./ScreenBulk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports